import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";

/**@Components */
import Card from "./card";

/**@apiFns */
import { fetchVendorResponseTime } from "../../../api/vendor";

/**@Constants */
import { base_URL } from "../../../config/config";

/**@Utils */
import { formatResponseTime, calculateResponseTimeChange } from "../../../utils/format-date";

export default function DashboardCards() {
  const { vendorId } = useParams();

  /**@States */
  const [updatedMetrics, setUpdatedMetrics] = useState([]);
  

  /**@DataFetching */
  const { data: metricsData } = useQuery({
    queryKey: ["vendorMetrics", vendorId],
    queryFn: async () => {
      const response = await axios.get(
        `${base_URL}/api/vendor-metrics/${vendorId}`
      );
      return response.data;
    },
    enabled: !!vendorId,
  });

  // Fetch vendor response time
  const { data: responseTimeData } = useQuery({
    queryKey: ["vendorResponseTime", vendorId],
    queryFn: () => fetchVendorResponseTime(vendorId),
    enabled: !!vendorId,
  });

  /**@LifeCycle */
    useEffect(() => {
      if (metricsData && responseTimeData) {
        const updated = [
          {
            title: "New Enquiries",
            value: metricsData?.newEnquiries?.current,
            change: metricsData?.newEnquiries?.percentageChange,
            isPositive: metricsData?.newEnquiries?.percentageChange >= 0,
          },
          {
            title: "Open Enquiries",
            value: metricsData?.openEnquiries?.current,
            change: metricsData?.openEnquiries?.percentageChange,
            isPositive: metricsData?.openEnquiries?.percentageChange >= 0,
          },
          {
            title: "Successful Enquiries",
            value: metricsData?.successfulEnquiries?.current,
            change: metricsData?.successfulEnquiries?.percentageChange,
            isPositive: metricsData?.successfulEnquiries?.percentageChange >= 0,
          },
          {
            title: "Average Response Time",
            value: formatResponseTime(responseTimeData?.averageResponseTime),
            change: calculateResponseTimeChange(responseTimeData),
            isPositive: calculateResponseTimeChange(responseTimeData) <= 0,
          },
        ];
  
        setUpdatedMetrics(updated);
      }
    }, [metricsData, responseTimeData]);

  return (
    <div className="overflow-x-auto lg:overflow-hidden">
      <div className="flex gap-4 w-max lg:w-full lg:grid lg:grid-cols-4">
        {updatedMetrics?.map((metric, index) => (
          <Card key={index} {...metric} />
        ))}
      </div>
    </div>
  )
}